export const getEventIndexById = (state, eventId) => {
  state.events.findIndex((event) => event.ID.toString() === eventId.toString());
};
